export enum CustomerStatusLabel {
    empty,
    green,
    amber,
    red,
    checked,
}
